import { action, observable, makeAutoObservable } from "mobx"

import type { PagedResultDto } from "@services/dto/pagedResultDto"
// import { PagedRoleResultRequestDto } from '@services/workflow/dto/PagedResultRequestDto'
import wfRoleService from "@services/workflow/wfRoleService"
import { initMultiLanguageField } from "@lib/helper"

class WfRoleStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable allRoles!: any[]
  @observable roleMembers!: any[]

  constructor() {
    makeAutoObservable(this)
    this.isLoading = false
  }
  @action
  async create(createWfRoleInput) {
    this.isLoading = true
    await wfRoleService
      .create(createWfRoleInput)
      .finally(() => (this.isLoading = false))
  }

  @action
  async update(updateWfRoleInput) {
    this.isLoading = true
    await wfRoleService
      .update(updateWfRoleInput)
      .finally(() => (this.isLoading = false))
  }

  @action
  async activateOrDeactivate(id: number, isActive) {
    await wfRoleService.activateOrDeactivate(id, isActive)
  }

  @action
  async get(id) {
    this.detailData = await wfRoleService.get(id)
  }

  @action
  async createWfRole() {
    this.detailData = {
      id: 0,
      names: initMultiLanguageField(),
      isActive: true,
    }
  }

  @action
  async getAll(pagedFilterAndSortedRequest: any) {
    this.isLoading = true
    this.tableData = await wfRoleService
      .getAll(pagedFilterAndSortedRequest)
      .finally(() => (this.isLoading = false))
  }

  @action
  async getList(moduleId?) {
    this.allRoles = await wfRoleService.getList({ moduleId })
  }

  @action
  async getRoleMembers(roleId) {
    this.roleMembers = await wfRoleService.getRoleMember({ roleId })
  }

  @action
  async updateRoleMembers(roleId, userIds) {
    await wfRoleService.updateRoleMember({ roleId, userIds })
    this.roleMembers = []
  }
}

export default WfRoleStore
